import { FC } from 'react';
import * as React from 'react';
import * as ReactGA from 'react-ga';
import { useApi } from 'src/@context/Api';
import Home from './Home';
import useReactRouter from 'use-react-router';
import Projects from './Projects';
import Contact from './Contact';
import News from './News';
import NewsEntry from './NewsEntry';
import { makeStyles, createStyles } from '@material-ui/styles';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet from 'src/constants/stylesheet';
import * as classNames from 'classnames';
import Project from './Project';
import PanelPage from './PanelPage';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      backgroundColor: 'rgb(48,48,48)',
      flex:'0 0 auto',
      marginTop: 'auto',
    },
    rootInner: {
      position: 'relative',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      [mediaQueries.Mobile]: {
        paddingLeft: spacing.Gutter.Mobile,
        paddingRight: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
      },
    },
    contactInformations: {
      display: 'flex',
      alignItems: 'flex-end',
      opacity: 1,
      transition: 'opacity .4s ease',
      [mediaQueries.Mobile]: {
        flexWrap: 'wrap',
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingTop: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingTop: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingTop: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop,
      },
    },
    column: {
      color: 'white',
      overflow: 'hidden',
      [mediaQueries.Mobile]: {
        flex: `100%`,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
      },
      '& a': {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    ContactTitle: {
      ...stylesheet.MainTitle,
      color: 'white',
      marginBottom: 2,
    },
    noFooter: {
      [mediaQueries.Mobile]: {
        display: 'none'
      }
    }
  }));

export type PageProps = {};

type Props = PageProps;

const Page: FC<Props> = () => {
  const cls = useStyles();
  const { location: { pathname } } = useReactRouter();
  const { get, app } = useApi();
  const [page, setPage] = React.useState<IPageDto>();

  const Config = app && app.Config;

  const fetchPage = async () => {
    const pageDto = await get(pathname);
    setPage(pageDto);
  }

  React.useEffect(() => {
    fetchPage();
  }, [pathname]);

  React.useEffect(
    () => {
      if (!app || !app.Config) { return; }
      const config = app.Config;

      if (!config.GoogleAnalyticsCode) { return; }

      ReactGA.initialize(`${config.GoogleAnalyticsCode}`);
      ReactGA.pageview(window.location.pathname);
    }, [page, app]);

  const scrollContainer = document.scrollingElement;
  React.useEffect(() => {
    if (!scrollContainer) { return };

    // if (scrollContainer.scrollTop > 0) {
    scrollContainer.scrollTop = 0
    // }

  }, [page]);

  return (
    <>
      {page && page.type === "Home" &&
        <Home
          {...page as HomeDto}
        />
      }
      {page && page.type === "Projects" &&
        <Projects
          {...page as ProjectsDto}
        />
      }
      {page && page.type === "Contact" &&
        <Contact
          {...page as ContactDto}
        />
      }
      {page && page.type === "News" &&
        <News
          {...page as NewsDto}
        />
      }
      {page && page.type === "NewsEntry" &&
        <NewsEntry
          {...page as NewsEntryDto}
        />
      }
      {page && page.type === "Project" &&
        <Project
          {...page as ProjectDto}
        />
      }
      {page && page.type === "PanelPage" &&
        <PanelPage
          {...page as PanelPageDto}
        />
      }
      <footer className={classNames(cls.root, page && page.type === "Home" && cls.noFooter)}>
        <div className={cls.rootInner}>
          <div className={cls.contactInformations}>
            <h3 className={classNames(cls.column, cls.ContactTitle)}>Nous contacter</h3>
            {Config &&
              <>
                <div className={cls.column} dangerouslySetInnerHTML={{ __html: Config.Address }} />
                <div className={cls.column} dangerouslySetInnerHTML={{ __html: Config.Contacts }} />
              </>
            }
          </div>
        </div>
      </footer>
    </>
  );
};

export default Page;



// WEBPACK FOOTER //
// ./src/Components/Page.tsx